<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.recurringEvents") }}</h3>
            </div>
            <div class="card-body">
                <table class="table table-striped table-hover table-responsive-md text-center">
                    <thead>
                        <tr>
                            <th>{{ $t("repeatingEvents.event") }}</th>
                            <th>{{ $t("repeatingEvents.startAt") }}</th>
                            <th>{{ $t("repeatingEvents.finishAt") }}</th>
                            <th>{{ $t("repeatingEvents.frequency") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="repeatingEvents.length">
                        <tr v-for="event in repeatingEvents" :key="event.id" class="align-middle">
                            <td>
                                <span v-if="event.event_type === 'vehicle_entry' && event.vehicle_entries.length">
                                    {{ event.vehicle_entries[0].carrier }}/{{ $t("repeatingEvents.vehicleEntry") }}
                                </span>
                                <span v-else-if="event.event_type === 'guestbook' && event.guestbooks.length">
                                    {{ event.guestbooks[0].guest_name }}/{{ $t("repeatingEvents.guestbook") }}
                                </span>
                            </td>
                            <td>{{ event.repeat_from ? $d(new Date(event.repeat_from), "short") : "--" }}</td>
                            <td>
                                {{ event.repeat_to ? $d(new Date(event.repeat_to), "short") : "--" }}
                            </td>
                            <td>{{ event.interval_days }}</td>
                            <td>
                                <button class="btn btn-primary btn-sm me-2" @click="goTo(event.id)">
                                    <icon icon="Search"></icon>
                                </button>
                                <button v-if="$store.getters.hasGatehousePerm('delete_patrollog')"
                                    class="btn btn-danger btn-sm" @click.stop="deleteEvent(event.id)">
                                    <icon icon="Trash"></icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6" class="text-center text-muted py-3">
                                {{ $t("repeatingEvents.notFound") }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from '@/components/Icon.vue';

export default {
    components: {
        Icon,
    },
    data() {
        return {
            repeatingEvents: []
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/repeating-events`)
                .then(response => {
                    this.repeatingEvents = response.data;

                })
                .catch(error => {
                    console.error("Error loading repeating events", error);
                });
        },
    },
}
</script>
<style lang="">

</style>